import { getGlobalHeadersAsObject } from "./global-headers";

export interface SystemSettings {
	profile_views_conn_gt_300: number;
	profile_views_conn_gt_200: number;
	profile_views_conn_gt_100: number;
	profile_views_conn_gt_30: number;
	profile_views_conn_gt_10: number;
	profile_views_conn_default: number;

	searches_conn_gt_500: number;
	searches_conn_default: number;

	company_views_conn_gt_200: number;
	company_views_conn_gt_100: number;
	company_views_conn_gt_30: number;
	company_views_conn_gt_10: number;
	company_views_conn_default: number;

	job_search_conn_gt_300: number;
	job_search_conn_default: number;

	limit_other: number;
	limit_quick_session: number;
	limit_talent_inbox: number;
	limit_quick_init: number;
	limit_profile_contact_info: number;
	limit_inmail_cost_info: number;
	limit_licdn: number;
	limit_send_invitation: number;
	limit_init: number;
	limit_full_init: number;

	dataminer_max_threads: number;
	hourly_fuse_limit: number;

	default_pitch_delay_days: number;
	outreach_quiet_period_days: number;

	llm_candidate_freshness_days: number;
	stale_profile_refresh_batch_size: number;

	max_mandatory_requirements: number;
	egenkonsult_requirement_text: string;

	keyword_search_max_workers: number;
	keyword_adaptive_min_evals: number;

	fill_llm_queue_enabled: boolean;
	minimum_llm_queue: number;
	minimum_llm_queue_first: number;
	minimum_llm_queue_unvisited: number;
	llm_queue_batch_size: number;
	llm_sequential_max_workers: number;
	llm_reasoning_max_tokens: number;
	llm_default_max_tokens: number;
	llm_use_batch_api: boolean;

	random_exploration_ratio: number;

	linkedin_search_gcq_enabled: boolean;
	linkedin_search_max_results_per_keyword: number;
	linkedin_search_pjb_reuse_hours: number;

	proxy_ip_cooldown_hours: number;
	static_proxy_assignment_percent: number;
	static_proxy_cache_max_age_days: number;

	promiscuous_min_accepted: number;

	ml_min_votes: number;
	ml_min_upvotes: number;
	ml_llm_min_evals: number;
	ml_llm_min_matches: number;

	restricted_penalty_divisor: number;
	something_not_right_penalty_divisor: number;
	penalty_lookback_weeks: number;

	bigquery_ml_enabled: boolean;
	bigquery_project_id: string;
	bigquery_dataset: string;
	bigquery_sync_batch_size: number;

	sim_min_upvotes: number;
	sim_min_llm_matches: number;
	ml_retrigger_cooldown_hours: number;
	ml_session_idle_minutes: number;

	bot_datamining_weight_none: number;
	bot_datamining_weight_50: number;
	bot_datamining_weight_10: number;
	bot_datamining_weight_1: number;
	bot_datamining_weight_0: number;
	bot_skip_maintenance_percent: number;
	min_outlook_account_age_hours: number;

	elasticsearch_indexing_enabled: boolean;
	elasticsearch_per_keyword_limit: number;
	es_reindex_batch_size: number;

	gcq_build_search_elastic: boolean;

	reranker_shadow_enabled: boolean;
	second_judge_shadow_enabled: boolean;

	gpq_weight_llm_refresh: number;
	gpq_weight_right_locations_also_viewed: number;
	gpq_weight_warmup: number;
	gpq_weight_right_locations_2y: number;
	gpq_weight_upvotes_also_viewed: number;
	gpq_weight_add_conn: number;
	gpq_weight_bots: number;
	gpq_weight_users: number;
}

export const fetchSystemSettings = async (): Promise<SystemSettings> => {
	const response = await fetch("/api/v2/system-settings/", {
		headers: { ...getGlobalHeadersAsObject() },
	});
	if (!response.ok) {
		throw new Error(`Failed to fetch system settings: ${response.statusText}`);
	}
	return response.json();
};

export const updateSystemSettings = async (
	data: Partial<SystemSettings>
): Promise<SystemSettings> => {
	const response = await fetch("/api/v2/system-settings/1/", {
		method: "PUT",
		headers: {
			"Content-Type": "application/json",
			...getGlobalHeadersAsObject(),
		},
		body: JSON.stringify(data),
	});
	if (!response.ok) {
		throw new Error(`Failed to update system settings: ${response.statusText}`);
	}
	return response.json();
};
